import { CSSProperties } from 'react';
import styled from 'styled-components';

export const iconStyle: CSSProperties = { marginRight: 6 };

export const NavWrapper = styled.div`
  display: flex;
  height: auto;
  align-items: center;
  flex-wrap: nowrap;

  @media (min-width: 600px) {
    display: flex;
    height: auto;
  }

  @media (min-width: 1200px) {
    padding-right: 1vw;
  }
`;
